import React from 'react';
import PropTypes from 'prop-types';

import { Loading } from 'components/Loading';

const StageLoading = ({ className }) => {
  return (
    <div className={className}>
      <Loading size={20} />
    </div>
  );
};

StageLoading.propTypes = {
  className: PropTypes.string,
};

export default StageLoading;
